var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrdner02B(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "40px",
    viewBox: "0 0 50 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Modul_Playlist_Ordner-02b__Modul/Playlist/Ordner-02b",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Modul_Playlist_Ordner-02b__Group",
    transform: "translate(11 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Modul_Playlist_Ordner-02b__Rectangle-Copy-2",
    d: "M0 0 7.90909091 0 9.56759921 2.812763 29 2.812763 29 22 0 22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Modul_Playlist_Ordner-02b__Rectangle",
    d: "M0 6 7.90909091 6 9.56759921 6 29 6 29 22 0 22z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdner02B);
export default __webpack_public_path__ + "static/media/Ordner-02b.68c16ff852ff7289935ca8e8c53858c1.svg";
export { ForwardRef as ReactComponent };